import { render } from "./KapibaraContent.vue?vue&type=template&id=0ab9530c"
import script from "./KapibaraContent.vue?vue&type=script&lang=js"
export * from "./KapibaraContent.vue?vue&type=script&lang=js"

import "./KapibaraContent.vue?vue&type=style&index=0&id=0ab9530c&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__